import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("sf_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data.user);
      setCompany(r.data.company);
    }).catch(() => {
      localStorage.removeItem("sf_token");
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sf_token", data.token);
    setUser(data.user);
    setCompany(data.company);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register-company", payload);
    localStorage.setItem("sf_token", data.token);
    setUser(data.user);
    setCompany(data.company);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("sf_token");
    setUser(null); setCompany(null);
  };

  return (
    <Ctx.Provider value={{ user, company, loading, login, register, logout }}>
      {children}
    </Ctx.Provider>
  );
}
